import ResultOfferCard from './ResultOfferCard';
import { formatResultDate, locationCode } from '../../utils/resultDisplay';
import { SITE_NAME } from '../../constants/site';

export default function CruiseResultCard({ item, searchParams }) {
  const portCode = locationCode(item.port);
  const bookingLines = [
    { label: 'Cruise line', value: item.line },
    { label: 'Port', value: item.port },
    { label: 'Destination', value: item.destination },
    { label: 'Price per guest', value: `$${item.price.toFixed(2)}` },
  ];

  return (
    <ResultOfferCard
      dateLabel={formatResultDate(item.departDate || searchParams?.get('depart'))}
      providerName={item.line}
      providerFallback={portCode}
      routeLeft={{ code: portCode, time: 'Embark' }}
      routeRight={{ code: locationCode(item.destination, 'SEA'), time: item.cabin }}
      routeDuration={`${item.nights} nights`}
      routeStops={item.destination}
      price={{ amount: item.price, currency: 'USD' }}
      pricePerLabel="Price per guest"
      priceFinePrint="Sample fare — not a live price"
      detailsTitle="Cruise Details"
      detailRows={[
        { label: 'Port', value: item.port },
        { label: 'Cabin', value: item.cabin },
      ]}
      bookNowProps={{
        serviceType: 'cruise',
        bookingPayload: {
          subject: `${SITE_NAME} — Cruise booking`,
          bookingLines,
          offer: {
            line: item.line,
            port: item.port,
            destination: item.destination,
            nights: item.nights,
            cabin: item.cabin,
            departDate: item.departDate,
          },
          price: {
            base: item.price,
            total: item.price,
            travelerLabel: '1 Guest',
          },
        },
      }}
    />
  );
}
